import styled from 'styled-components'
import { Grid, Row, Col } from 'react-flexbox-grid'
import get from 'lodash/get'

import { NavBarContent, StyledBar, StyledNavBarItem } from 'components/NavBar/styled'

export const StyledAppContainer = styled(Grid)`
	div& {
		margin: auto;
		padding: 0;
		max-width: 1920px;
		min-width: 1400px;
		width: 100%;
	}
	${/* App specific NavBar styles */''}
	#sectionContent {
		min-height: ${({ theme }) => `calc(100vh - ${get(theme, 'navBarHeight.bottomNav')})`};
		& > ${NavBarContent} {
			flex-grow: 1;
			background-color: #f8fdff;
			padding: 20px;
			padding-top: 7px;
			& > .row {
				${({ theme: { sectionColPadding } }) => `
				margin-left: -${sectionColPadding};
				margin-right: -${sectionColPadding};
				& > div[class^="col"] {
					padding-left: ${sectionColPadding};
					padding-right: ${sectionColPadding};
				}
				`}
			}
		}
		& > ${StyledBar} > ${StyledNavBarItem} {
			flex-direction: column;
			flex-basis: 100%;
			max-width: 9.1%;
			border-top: solid 3px transparent;
			position: relative;
			transition: border-top .8s;
			text-align: center;
			&.active {
				border-top: ${({ theme }) => `solid 3px ${theme.activeColor}`};
				background-color: ${({ theme }) => theme.primaryHover};
			}
			&.active + *:before {
				display: none;
			}
		}
	}

	.bottomnav {
		${StyledBar} {
			flex-direction: row;
			justify-content: flex-end;
		}
		&-logo {
			padding: 0 20px;
			max-width: 250px;
			justify-content: space-between;
			font-size: 16px;
			svg {
				margin-top: 2px;
			}
		}
		&-company {
			max-width: 200px;
			padding: 0 10px;
			font-size: 16px;
		}
		&-switch-ui {
			max-width: 250px;
			padding: 0 10px;
			font-size: 16px;
		}
		&-logout {
			max-width: 300px;
		}
	}
`

export const FormRow = styled(Row)(({ theme }) => `
	div& {
		margin-left: calc(-${theme.formColGap} / 2);
		margin-right: calc(-${theme.formColGap} / 2);
	}
`)
export const FormCol = styled(Col).withConfig({
	shouldForwardProp: prop => !['narrow', 'autoWidth'].includes(prop)
})(({ autoWidth, narrow, theme }) => `
	div& {
		flex-grow: 0;
		flex-basis: ${autoWidth ? 'auto' : `calc(${narrow ? theme.formCoNarrowlWidth : theme.formColWidth} + ${theme.formColGap})`};
		padding-left: calc(${theme.formColGap} / 2);
		padding-right: calc(${theme.formColGap} / 2);
	}
`)
